// extracted by mini-css-extract-plugin
export var about = "CoursesAgenda-module--about--eaf58";
export var course = "CoursesAgenda-module--course--6da66";
export var courseAndType = "CoursesAgenda-module--courseAndType--40587";
export var courseCondensedInfo = "CoursesAgenda-module--courseCondensedInfo--be98d";
export var courseItem = "CoursesAgenda-module--courseItem--3c97f";
export var courseItemHeader = "CoursesAgenda-module--courseItemHeader--32582";
export var courseType = "CoursesAgenda-module--courseType--78ac4";
export var duration = "CoursesAgenda-module--duration--2e31d";
export var evenRow = "CoursesAgenda-module--evenRow--827d3";
export var filterCategory = "CoursesAgenda-module--filterCategory--d2a0c";
export var filterSelector = "CoursesAgenda-module--filterSelector--a95e5";
export var filters = "CoursesAgenda-module--filters--16bdb";
export var filtersGrid = "CoursesAgenda-module--filtersGrid--77685";
export var header = "CoursesAgenda-module--header--003fb";
export var holder = "CoursesAgenda-module--holder--d85c9";
export var language = "CoursesAgenda-module--language--6ea73";
export var legend = "CoursesAgenda-module--legend--01305";
export var more = "CoursesAgenda-module--more--7ffde";
export var notes = "CoursesAgenda-module--notes--35dc5";
export var region = "CoursesAgenda-module--region--5bf56";
export var sectionHeader = "CoursesAgenda-module--sectionHeader--b4bef";
export var when = "CoursesAgenda-module--when--f24fe";
export var whereAndWhen = "CoursesAgenda-module--whereAndWhen--c5bb6";
export var wrapper = "CoursesAgenda-module--wrapper--640a9";